import { ResetPageAction, ResetStoreAction, RootReducers } from './store.types';

export const resetPage = (payload: RootReducers): ResetPageAction => ({
  type: 'RESET_PAGE',
  payload
});

export const resetStoreData = (): ResetStoreAction => ({
  type: 'RESET_STORE_DATA'
});
